// TSS vite/03 §"Query keys".

export const asocebuKeys = {
    all: ['asocebu'],
    crosses: (filters) => ['asocebu', 'crosses', filters],
};
